import React from "react";

export const CheckCircle = ({ active, success, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
        fill={active ? "#ECEEFF" : success ? "#07A35A" : "#F9F9F9"}
      />
      <path
        d="M9.28971 16.2905L5.69971 12.7005C5.51246 12.5137 5.40723 12.2601 5.40723 11.9955C5.40723 11.731 5.51246 11.4774 5.69971 11.2905C6.08971 10.9005 6.71971 10.9005 7.10971 11.2905L9.99971 14.1705L16.8797 7.29055C17.2697 6.90055 17.8997 6.90055 18.2897 7.29055C18.6797 7.68055 18.6797 8.31055 18.2897 8.70055L10.6997 16.2905C10.3197 16.6805 9.67971 16.6805 9.28971 16.2905Z"
        fill={active ? "#1329EF" : success ? "#FFFFFF" : "#202124"}
      />
    </svg>
  );
};

export const PlusCircle = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
        fill={active ? "#ECEEFF" : "#F9F9F9"}
      />
      <path
        d="M16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
        fill={active ? "#1329EF" : "#202124"}
      />
    </svg>
  );
};
